import { useEffect, useState } from 'react';

export const useMetaKeyPressed = () => {
  const [isMetaKeyPressed, setIsMetaKeyPressed] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey) {
        setIsMetaKeyPressed(true);
      }
    };
    const handleKeyUp = () => setIsMetaKeyPressed(false);

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  return isMetaKeyPressed;
};
